import firebase from "firebase/compat/app";
import "firebase/compat/auth";

export const isRecaptchaAvailable = () => {
  if (typeof window.grecaptcha === "undefined" || typeof firebase.auth.RecaptchaVerifier === "undefined") {
    return false;
  }
  return true;
};

export const isRecaptchaSdkAvailable = () => typeof firebase.auth.RecaptchaVerifier !== "undefined";

/** Used by business logic to decide credential recovery (reset widget + user message). */
export const RECAPTCHA_CREDENTIAL_ERROR_CODES = [
  "auth/invalid-app-credential",
  "auth/invalid-verification-code",
  "auth/missing-client-identifier",
];

export const isRecaptchaCredentialError = (error) => RECAPTCHA_CREDENTIAL_ERROR_CODES.includes(error?.code);

/** reCAPTCHA verifier / token issues — typically before or during send SMS. */
export const RECAPTCHA_VERIFIER_ERROR_CODES = [
  "auth/invalid-app-credential",
  "auth/missing-client-identifier",
  "auth/missing-app-credential",
  "auth/captcha-check-failed",
  "auth/unauthorized-domain",
  "auth/network-request-failed",
];

/** SMS verification session / code issues — typically during code confirmation. */
export const PHONE_VERIFICATION_ERROR_CODES = [
  "auth/invalid-verification-code",
  "auth/code-expired",
  "auth/invalid-verification-id",
  "auth/session-expired",
  "auth/missing-verification-code",
  "auth/missing-verification-id",
];

/** Other phone auth errors useful for debug observability in Sentry. */
export const PHONE_AUTH_DEBUG_ERROR_CODES = [
  "auth/invalid-multi-factor-session",
  "auth/too-many-requests",
  "auth/quota-exceeded",
  "auth/invalid-phone-number",
  "auth/missing-phone-number",
  "auth/operation-not-allowed",
  "auth/user-disabled",
  "auth/internal-error",
  "auth/app-not-authorized",
  "auth/web-storage-unsupported",
];

export const RECAPTCHA_DEBUG_ERROR_CATEGORIES = {
  verifier: RECAPTCHA_VERIFIER_ERROR_CODES,
  verification: PHONE_VERIFICATION_ERROR_CODES,
  other: PHONE_AUTH_DEBUG_ERROR_CODES,
};

export const ALL_RECAPTCHA_DEBUG_ERROR_CODES = [
  ...new Set([...RECAPTCHA_VERIFIER_ERROR_CODES, ...PHONE_VERIFICATION_ERROR_CODES, ...PHONE_AUTH_DEBUG_ERROR_CODES]),
];

export const getRecaptchaAuthErrorCategory = (error) => {
  const code = error?.code;
  if (!code) {
    return null;
  }

  if (RECAPTCHA_VERIFIER_ERROR_CODES.includes(code)) {
    return "verifier";
  }
  if (PHONE_VERIFICATION_ERROR_CODES.includes(code)) {
    return "verification";
  }
  if (PHONE_AUTH_DEBUG_ERROR_CODES.includes(code)) {
    return "other";
  }

  return null;
};

export const isRecaptchaDebugAuthError = (error) => ALL_RECAPTCHA_DEBUG_ERROR_CODES.includes(error?.code);

export const getRecaptchaAuthErrorMeta = (error) => {
  const code = error?.code || "unknown";
  const category = getRecaptchaAuthErrorCategory(error);

  return {
    firebaseErrorCode: code,
    errorCategory: category || "unclassified",
    errorMessage: error?.message || "",
  };
};
